import { endpointIdFactory } from '@seccl/api-swr';
import { ClientManagementApi } from '@seccl/client';

import { apiFactory } from '../../apiFactory';

export const clientManagementApiIds = endpointIdFactory('clientManagement', ClientManagementApi);

/** Controller factory for accessing endpoint hooks */
export const clientManagementApi = apiFactory.createAxiosOpenApiController(
  clientManagementApiIds.controllerKey,
  ClientManagementApi
);
